import { render, staticRenderFns } from "./Convocatorias.vue?vue&type=template&id=6f4c7fdd&"
import script from "./Convocatorias.vue?vue&type=script&lang=js&"
export * from "./Convocatorias.vue?vue&type=script&lang=js&"
import style0 from "./Convocatorias.vue?vue&type=style&index=0&id=6f4c7fdd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports